import { Gift, Heart, PartyPopper, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const useCases = [
  {
    id: "pesnya-na-den-rozhdeniya",
    icon: Gift,
    title: "Песня на день рождения",
    subtitle: "Персональный хит — лучший подарок",
    description: "Забудьте про стандартные открытки. Персональная песня на день рождения — подарок, который запомнится навсегда. Расскажите об имениннике: как зовут, чем увлекается, какие у него смешные привычки — и получите настоящий музыкальный хит за 3 минуты.",
  },
  {
    id: "pesnya-pro-druga",
    icon: Users,
    title: "Песня про друга",
    subtitle: "Удиви друга персональным хитом",
    description: "Расскажите про совместные приключения, внутренние шутки и фирменные фразы — и получите трек, от которого друг будет в восторге. Песня про друга — признание в дружбе, упакованное в хит.",
  },
  {
    id: "pesnya-dlya-vecherinki",
    icon: PartyPopper,
    title: "Хит для вечеринки",
    subtitle: "Зажги танцпол персональным треком",
    description: "Персональная песня для вечеринки — главный хит вечера. Закажите пакет из 15 треков и создайте хит про каждого гостя. Подходит для корпоративов, домашних праздников, свадеб и выпускных.",
  },
  {
    id: "muzykalnyj-podarok",
    icon: Heart,
    title: "Музыкальный подарок",
    subtitle: "Оригинальный подарок с душой",
    description: "Персональная песня — музыкальный подарок, который невозможно купить в магазине. Каждый трек уникален: текст на основе вашей истории и профессиональная музыка в любом жанре. Эмоции, которые останутся навсегда.",
  },
];

const UseCasesSection = () => {
  return (
    <section className="py-12 relative" id="use-cases">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-3 text-foreground">
            Для каких случаев <span className="text-gradient-primary">подойдёт</span>
          </h2>
          <p className="text-muted-foreground text-base max-w-md mx-auto">
            Персональная песня — универсальный подарок для любого события
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {useCases.map((useCase) => (
            <article key={useCase.id} id={useCase.id} className="p-6 rounded-2xl bg-card border border-border scroll-mt-20">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <useCase.icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold text-foreground">{useCase.title}</h3>
                  <p className="text-primary text-xs font-medium">{useCase.subtitle}</p>
                </div>
              </div>
              <p className="text-muted-foreground text-sm leading-relaxed">{useCase.description}</p>
              <div className="mt-4">
              <Button size="sm" variant="outline" asChild>
                  <Link to="/create">
                    🎵 Создать хит
                  </Link>
                </Button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
